export default {
      id: "more_horizontal-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#more_horizontal",
      toString: function () {
        return this.url;
      }
    }